import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';

import {fuseAnimations} from '@fuse/animations';
import {DeleteNotificationDialogComponent} from "../../../notification/dialog/deleteNotificationDialog.component";
import {FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {NoteService} from "../../service/note.service";
import {NewNoteDialogComponent} from "../../dialog/newNoteDialog.component";

@Component({
    selector: 'note-list-sidebar',
    templateUrl: './list-sidebar.component.html',
    styleUrls: ['./list-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class NoteListSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    loadingIndicator: boolean;
    newNoteDialogRef: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router,
        public _matDialog: MatDialog,
        public noteService: NoteService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New note
     */
    newNote(): void {
        this.newNoteDialogRef = this._matDialog.open(NewNoteDialogComponent, {
            panelClass: 'new-note-dialog',
            data      : {
                action : 'new-note',
            },
            width: '550px',
        });

        this.newNoteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.noteService.create(response.getRawValue()).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.newNoteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
